import { g, layers } from '@hcie/core';

export class CropAction {
    public id = 'crop';
    public description = 'Kırpma';
    private oldWidth: number;
    private oldHeight: number;
    private oldLayerData: { index: number, data: ImageData }[] = [];
    private newWidth: number;
    private newHeight: number;
    private rect: { x: number, y: number, w: number, h: number };

    constructor(rect: { x: number, y: number, w: number, h: number }) {
        this.rect = rect;
        this.oldWidth = g.image_width;
        this.oldHeight = g.image_height;
        this.newWidth = Math.floor(rect.w);
        this.newHeight = Math.floor(rect.h);

        // Backup all layers
        layers.forEach((layer, index) => {
            const ctx = layer.ctx as CanvasRenderingContext2D;
            this.oldLayerData.push({
                index,
                data: ctx.getImageData(0, 0, this.oldWidth, this.oldHeight)
            });
        });
    }

    execute() {
        this.applyCrop(this.newWidth, this.newHeight, this.rect.x, this.rect.y);
    }

    undo() {
        // Restore dimensions
        g.image_width = this.oldWidth;
        g.image_height = this.oldHeight;

        // Restore each layer
        this.oldLayerData.forEach(item => {
            const layer = layers[item.index];
            if (layer) {
                layer.canvas.width = this.oldWidth;
                layer.canvas.height = this.oldHeight;
                (layer.ctx as CanvasRenderingContext2D).putImageData(item.data, 0, 0);
            }
        });

        if (window.renderLayers) window.renderLayers();
        if (typeof (window as any).resizeCanvas === 'function') {
            (window as any).resizeCanvas(g.image_width, g.image_height);
        }
    }

    redo() {
        this.execute();
    }

    private applyCrop(nw: number, nh: number, x: number, y: number) {
        g.image_width = nw;
        g.image_height = nh;

        layers.forEach(layer => {
            const oldCanvas = layer.canvas;
            const newCanvas = document.createElement('canvas');
            newCanvas.width = nw;
            newCanvas.height = nh;
            const nctx = newCanvas.getContext('2d');
            if (nctx) {
                nctx.drawImage(oldCanvas, -x, -y);
            }
            
            layer.canvas.width = nw;
            layer.canvas.height = nh;
            (layer.ctx as CanvasRenderingContext2D).drawImage(newCanvas, 0, 0);
        });

        if (window.renderLayers) window.renderLayers();
        if (typeof (window as any).resizeCanvas === 'function') {
            (window as any).resizeCanvas(g.image_width, g.image_height);
        }
    }
}

/**
 * Global function to perform crop.
 */
export function performCrop(x: number, y: number, w: number, h: number) {
    if (w <= 0 || h <= 0) return;
    
    const action = new CropAction({ x, y, w, h });
    action.execute();
    
    if ((window as any).historyManager) {
        (window as any).historyManager.push(action);
    }
}

// Expose to window
if (typeof window !== 'undefined') {
    (window as any).performCrop = performCrop;
}
